import { render, staticRenderFns } from "./CompetitionWinner.vue?vue&type=template&id=011f6b07&"
import script from "./CompetitionWinner.vue?vue&type=script&lang=js&"
export * from "./CompetitionWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports